import {Keys} from "@/constants/key";
import SceneUtils from "@/utils/scene-utils";
import {Replica} from "@/store/meet/types";
import PlayerStore from "@/store/player";

export default class AtlasUtils {

    private static readonly P2_PREFIX = 'p2_';
    private static readonly P3_PREFIX = 'p3_';
    private static readonly P4_PREFIX = 'p4_';
    private static readonly P8_PREFIX = 'p8_';
    private static readonly P9_PREFIX = 'p9_';
    private static readonly P4X_PREFIX = 'p4x-';
    private static readonly P5_PREFIX = 'p5_';
    private static readonly P6_PREFIX = 'p6_';
    private static readonly P7X_PREFIX = 'p7x_';
    private static readonly P6_SCEN_PREFIX = 'p6s_';
    private static readonly OF_PREFIX = 'of_';
    private static readonly BOSSES_PREFIX = 'swb-';
    private static readonly CATS_PREFIX = 'cc';
    private static readonly AMETIST_PREFIX = 'am';
    private static readonly WATER_PREFIX = 'wt';
    private static readonly ANGEL_PREFIX = 'myth-angel';

    private static readonly ATL_AVAS = ['man-8', 'man-9', 'man-10', 'man-11', 'woman-8', 'woman-9', 'woman-10', 'woman-11'];

    public static getCreatureBattleAtlas(image: string): string {
        if (!image) {
            return Keys.ATLAS_CREATURES_BATTLE_1;
        }
        if (image.startsWith(AtlasUtils.P2_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_2;
        }
        if (image.startsWith('man') || image.startsWith('woman')) {
            if (AtlasUtils.ATL_AVAS.includes(image)) {
                return Keys.ATLAS_ATL_AVA;
            }
        }
        if (image.startsWith(AtlasUtils.P4_PREFIX) || image.startsWith(AtlasUtils.BOSSES_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_4;
        }
        if (image.startsWith(AtlasUtils.P5_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_5;
        }
        if (image.startsWith(AtlasUtils.OF_PREFIX)) {
            return Keys.ATLAS_OF;
        }
        if (image.startsWith(AtlasUtils.P6_SCEN_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_SCEN_8;
        }
        if (image === 'sur_arch' || image === 'sur_silap') {
            return Keys.ATLAS_HERO_8;
        }
        if (image.startsWith(AtlasUtils.P6_PREFIX) || image.startsWith('port_')) {
            if (image.startsWith('p6_young') || image.startsWith('p6_super') || image.startsWith('p6_epic') || image.startsWith('port_')) {
                return Keys.ATLAS_HERO_8;
            }
            return Keys.ATLAS_CREATURES_BATTLE_8;
        }
        if (image.startsWith('mon_') || image.startsWith('ob_')) {
            return Keys.ATLAS_HERO_9;
        }
        if (image.startsWith(AtlasUtils.P8_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_10;
        }
        if (image.startsWith(AtlasUtils.P9_PREFIX)) {
            return Keys.ATLAS_CREATURES_BATTLE_11;
        }
        if (image.startsWith("p8s")) {
            return Keys.ATLAS_CREATURES_BATTLE_9;
        }
        if (image.startsWith(AtlasUtils.CATS_PREFIX)) {
            return Keys.ATLAS_BATTLE_CATS;
        }
        if (image.startsWith(AtlasUtils.AMETIST_PREFIX)) {
            return Keys.ATLAS_BATTLE_AM;
        }
        if (image.startsWith(AtlasUtils.WATER_PREFIX)) {
            return Keys.ATLAS_BATTLE_WT;
        }
        if (image.startsWith(AtlasUtils.ANGEL_PREFIX)) {
            return Keys.ATLAS_ANGELS;
        }
        if (!SceneUtils.getCurrentScene().textures.exists(Keys.ATLAS_CREATURES_BATTLE_1)) {
            return Keys.ATLAS_CREATURES_BATTLE_0;
        }
        if (image.startsWith('swl_') || image.startsWith('yot-')) {
            return Keys.ATLAS_CREATURES_BATTLE_7;
        }
        if(image.startsWith('trb-')){
            return Keys.ATLAS_TRIPLE_BATTLES;
        }
        if(image.startsWith('sdq-')){
            return Keys.ATLAS_SIDE_QUESTS;
        }
        if (image.startsWith("p9s")) {
            return Keys.ATLAS_P9_BATTLE_CREATURES_V2;
        }
        return Keys.ATLAS_CREATURES_BATTLE_1;
    }

    public static getReplicaImage(r: Replica): string {
        if(r.imageId === '{hero}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            return isFemale ? 'edu-woman1' : 'edu-man1';
        }
        if(r.imageId === '{marko}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            return isFemale ? 'mar' : 'marko';
        }
        if(r.imageId === '{p6_hero_1}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            return isFemale ? 'dark_alice' : 'dark_jonny';
        }
        if(r.imageId === '{p6_hero_2}') {
            let isFemale = PlayerStore.getPlayer()!.companionImage.includes('female');
            return isFemale ? 'dark_alice_t' : 'dark_johnny_t';
        }
        return r.imageId!;
    }

    public static getReplicaAtlas(r: Replica): string {
        if(r.imageId == '{hero}'){
            return 'atlas_edu';
        }
        if (r.imageId == '{p6_hero_1}' || r.imageId == '{p6_hero_2}'){
            return 'atlas_edu_6';
        }
        if (r.imageId == '{marko}'){
            return 'atlas_edu_7';
        }

        if(r.atlasId){

            if(r.atlasId == "creature_battle") {
                return this.getCreatureBattleAtlas(r.imageId!);
            } else if (r.atlasId == "creature_road") {
                return this.getCreatureRoadAtlas(r.imageId!);
            }
            return r.atlasId;
        }
        return "";
    }

    public static getCreatureRoadAtlas(image: string | undefined | null): string {
        if (image && image.startsWith(AtlasUtils.P2_PREFIX)) {
            return Keys.ATLAS_CREATURES_ROAD_2
        }
        if (image && (image.startsWith(AtlasUtils.P4_PREFIX) || image.startsWith(AtlasUtils.BOSSES_PREFIX))) {
            return Keys.ATLAS_CREATURES_ROAD_4;
        }
        if (image && (image.startsWith(AtlasUtils.P5_PREFIX))) {
            return Keys.ATLAS_CREATURES_ROAD_5;
        }
        if (image && (image.startsWith(AtlasUtils.P6_PREFIX))) {
            return Keys.ATLAS_CREATURES_ROAD_8;
        }
        if (image && (image.startsWith(AtlasUtils.P8_PREFIX))) {
            return Keys.ATLAS_CREATURES_ROAD_9;
        }
        if (image && (image.startsWith(AtlasUtils.P9_PREFIX))) {
            return Keys.ATLAS_CREATURES_ROAD_11;
        }
        if (image && (image.startsWith(AtlasUtils.CATS_PREFIX))) {
            return Keys.ATLAS_ROAD_CATS;
        }
        return Keys.ATLAS_CREATURES_ROAD;
    }

    public static getConsumableShadeAtlas(image: string): string {
        if (image.startsWith(AtlasUtils.P2_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_SHADE_2;
        } else if (image.startsWith(AtlasUtils.P4_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_SHADE_4;
        } else if(image.startsWith(AtlasUtils.P4X_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_SHADE_4X;
        } else if(image.startsWith(AtlasUtils.P6_PREFIX)) {
            return Keys.ATLAS_CONS_SHADE_6;
        } else if(image.startsWith(AtlasUtils.P7X_PREFIX)) {
            return Keys.ATLAS_CONS_SHADE_7;
        }
        return Keys.ATLAS_CONSUMABLES_SHADE;
    }

    public static getConsumableNoShadeAtlas(image: string): string | undefined {
        if (image.startsWith(AtlasUtils.P2_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_NO_SHADE_2;
        } else if (image.startsWith(AtlasUtils.P4_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_NO_SHADE_4;
        } else if(image.startsWith(AtlasUtils.P4X_PREFIX)) {
            return Keys.ATLAS_CONSUMABLES_NO_SHADE_4X;
        } else if (image.startsWith('add-')){
            return undefined;
        } else if(image.startsWith(AtlasUtils.P6_PREFIX)) {
            return Keys.ATLAS_CONS_NO_SHADE_6;
        } else if(image.startsWith(AtlasUtils.P7X_PREFIX)) {
            return Keys.ATLAS_CONS_NO_SHADE_7;
        }
        return Keys.ATLAS_CONSUMABLES_NO_SHADE;
    }

    public static getPointerAtlas(image: string): string {
        if (image === 'pointer-easy' || image === 'pointer-easy-right') {
            return Keys.ATLAS_POINTERS_ADD;
        } else if (image.startsWith(AtlasUtils.P2_PREFIX)) {
            return Keys.ATLAS_POINTERS_2;
        } else if (image.startsWith(AtlasUtils.P3_PREFIX)) {
            return Keys.ATLAS_POINTERS_3;
        } else if (image.startsWith(AtlasUtils.P4_PREFIX)) {
            return Keys.ATLAS_POINTERS_4;
        } else if (image.startsWith('pointer-sdq-')){
            return Keys.ATLAS_POINTERS_SIDE_QUESTS;
        } else if (image.startsWith('pointer-saint-stone')){
            return Keys.ATLAS_POINTERS_ADD_2;
        } else if (image.startsWith(AtlasUtils.P8_PREFIX)) {
            return Keys.ATLAS_POINTERS_8;
        }else if (image.startsWith(AtlasUtils.P9_PREFIX)) {
            return Keys.ATLAS_P9_POINTER;
        }
        return Keys.ATLAS_POINTERS;
    }
}
